import { Big } from 'big.js';

export const PriceFormatter = {
  formatPrice(num: number | Big | null): string {
    if (num instanceof Big) {
      num = Number(num.toFixed(2));
    }
    if (num !== null && !isNaN(num)) {
      return num.toLocaleString('de-DE', {maximumFractionDigits: 2, minimumFractionDigits: 2});
    }
    return '';
  },
  formatBasePrice(basePriceValue: Big, referenceUnitString: string): string {
    return `${PriceFormatter.formatPrice(basePriceValue)} €/${referenceUnitString}`;
  },
  formatFillQuantity(num: number): string {
    if (num % 1 !== 0) {
      return num.toLocaleString('de-DE', {maximumFractionDigits: 2, minimumFractionDigits: 2});
    }
    return num.toLocaleString('de-DE', {maximumFractionDigits: 0});
  },
};
